import React from "react";
import { Link } from "react-router-dom";

const extractSummary = (htmlContent, maxLength = 170) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlContent;
  const textContent = tempElement.textContent || tempElement.innerText || "";

  if (textContent.length > maxLength) {
    return textContent.substring(0, maxLength) + "...";
  }

  return textContent;
};

const EventsList = ({ eventsData, currentLanguage }) => {
  // Sort events by created time descending
  const sortedEvents = [...eventsData].sort((a, b) => new Date(b.created.time) - new Date(a.created.time));

  return (
    <section>
      <div className="bg-gray-300">
        <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
          <div className="flex flex-wrap pt-5">
            {sortedEvents.map((events) => {
              const summary = extractSummary(events.body.value, 170);
              return (
                <div key={events.id} className="md:w-1/3 mb-5 px-3">
                  <div className="right-border-around relative w-full pt-15 pr-15 pb-0 pl-0">
                    <img
                      src={events.imageAbout.url}
                      alt={events.imageAbout.alt}
                      className="relative w-full z-10"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="bg-[#ffffff] h-auto sm:h-auto lg:h-auto flex flex-col justify-between p-4">
                    <div className="font-body">
                      <h2 className="text-[18px] font-heading text-indian-red text-justify font-bold p-[20px_10px_10px] mt-[-20px] lg:line-clamp-1 md:line-clamp-1 sm:line-clamp-none md:h-11 md:mb-2 lg:h-12">
                        {events.title}
                      </h2>
                      <p className="text-justify font-body text-[14px] pb-1 mb-2 px-2 overflow-hidden h-16 line-clamp-3 ">{summary}</p>
                    </div>
                    <div className="text-center">
                      <Link
                        to={`/${currentLanguage === 'en' ? '' : 'hi/'}events/${events.path.split("/").pop()}`}
                      >
                        <button
                          type="button"
                          className="bg-warm-orange text-white font-semibold font-body hover:underline rounded-lg text-sm mt-3 px-5 py-2.5 mb-4"
                        >
                          {currentLanguage === 'en' ? 'Read More' : 'अधिक पढ़ें'}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsList;
